<mg-table [collectionComponent]="this" matSort stickyHeaders>

	<ng-container matColumnDef="title">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Titel </th>
        <td mat-cell *matCellDef="let row"> {{row.title}} </td>
    </ng-container>

    <ng-container matColumnDef="message">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Bericht </th>
        <td mat-cell *matCellDef="let row"> {{row.message}} </td>
    </ng-container>

	<ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Datum bericht </th>
        <td mat-cell *matCellDef="let row"> {{row.date | date}} </td>
    </ng-container>

	<ng-container matColumnDef="expiringDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Einde bericht </th>
        <td mat-cell *matCellDef="let row"> {{row.expiringDate | date}} </td>
    </ng-container>

    <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Type </th>
        <td mat-cell *matCellDef="let row"> {{getType(row.type)}} </td>
    </ng-container>

</mg-table>
